let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7P2dc")).then(() => parcelRequire('7RTW6'));